import { useFlags } from "launchdarkly-react-client-sdk";

export const useStrictKnowledgeAssessment = (): boolean => {
  const { strictKnowledgeAssessment } = useFlags();
  return !!strictKnowledgeAssessment;
};
